import EditPhone from './EditPhone';
export default EditPhone;
